import { ApiResponse, getData, postJson } from './Apis';

export type SupplementaryInfoModel = {
    SupplementaryInfoId: number,
    ApplicantRef?: number,
    DateAdded: string,
    Type: string,
    Body: string,
    Applications: string[],
}

export async function API_SupplementaryInformation(): Promise<ApiResponse<SupplementaryInfoModel[]>> {
    return await getData<ApiResponse<SupplementaryInfoModel[]>>(`webapi/candidate/supplementaryinfo/GetAllCandidate`);
}

export async function API_AddSupplementaryInformation(data: SupplementaryInfoModel): Promise<ApiResponse<string>> {
    return await postJson<ApiResponse<string>>(`webapi/candidate/supplementaryinfo/AddAdditional`, data);
}
